import { render, staticRenderFns } from "./TaskNavigation.vue?vue&type=template&id=6ba5ab72&scoped=true&"
import script from "./TaskNavigation.vue?vue&type=script&lang=js&"
export * from "./TaskNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TaskNavigation.vue?vue&type=style&index=0&id=6ba5ab72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba5ab72",
  null
  
)

export default component.exports